<template>
    <div class="py-4 shadow-lg">
        <div class="flex gap-8 items-center" :class="props.wide ? 'container-left' : 'container'">
            <slot />
        </div>
    </div>
</template>
<script setup lang="ts">
const props = withDefaults(defineProps<{ wide?: boolean }>(), { wide: false });
</script>
